// @flow
import React from "react";
import withStyles from "elevate-ui/withStyles";
import { withGlobalContext } from "../common/GlobalContext";
import Color from "color";
import classNames from "classnames";

import RenderNavItem from "./RenderNavItem";
import LoginLinks from "./LoginLinks";
import MobileLoginLinks from "./MobileLoginLinks";
import SignInSignUp from "./SignInSignUp";

import type { $Site, $SiteUser } from "flow/types";

type $Props = {
  site: $Site,
  pathName: string,
  classes: Object,
  headerNav: Function,
  siteUser: $SiteUser,
};

const RenderNavItems = ({
  site: {
    productType,
    uiConfig: { nav },
  },
  pathName,
  classes,
  headerNav,
}: $Props) => {
  const isDMS = productType === "dms";
  const isIDX = productType === "idx";
  const isIDXFree = productType === "idx-free";

  if (!(nav && nav.length)) {
    return null;
  }

  return (
    <ul
      className={classNames({
        [classes.navBarList]: true,
        [classes.v2Headers]:
          headerNav === "threeColumnNavBar" ||
          headerNav === "officeLogoRightSideNavBar",
      })}
    >
      {pathName !== "/" && (isDMS || isIDX) ? (
        <li>
          <a href="/">Home</a>
        </li>
      ) : null}
      {!isIDXFree ? (
        nav.map((item, idx) => (
          <RenderNavItem key={idx} item={item} idx={idx} />
        ))
      ) : (
        <li>
          <a href="/listings" className="jq__search-topnav">
            Advanced Search
          </a>
        </li>
      )}
      {(headerNav === "default" || isIDXFree) && <LoginLinks />}
      {headerNav === "agentImageRightSideNavBar" && <MobileLoginLinks />}
      {headerNav === "threeColumnNavBar" ||
      headerNav === "officeLogoRightSideNavBar" ? (
        <SignInSignUp />
      ) : null}
    </ul>
  );
};

const styles = (theme) => {
  const hoverColor = Color(theme.colors.primary["500"])
    .darken(0.5)
    .string();
  return {
    navBarList: {
      float: "none",
      margin: "8px -15px",
      paddingLeft: "0",
      listStyle: "none",
      "& li a": {
        color: theme.colors.primaryFontColor,
        padding: "8px 15px",
        margin: "6px auto",
        lineHeight: "20px",
        display: "block",
        position: "relative",
        fontSize: "1em",
        "&:hover, &:focus": {
          textDecoration: "none",
          backgroundColor: hoverColor,
        },
      },
      [theme.breakpoints(900)]: {
        display: "inline-block",
        margin: "0",
        "& > li": {
          position: "relative",
          float: "left",
        },
      },
    },
    v2Headers: {
      "& > li > a": {
        padding: "12px 14px",
        margin: "4px auto 0",
        transition: "background-color 150ms ease",
        fontSize: "16px",
        [theme.breakpoints(900)]: {
          fontSize: "13px",
        },
        [theme.breakpoints(1120)]: {
          padding: "24px 28px",
          fontSize: "14px",
        },
        "&:after": {
          display: "none",
          [theme.breakpoints(900)]: {
            display: "block",
            content: "''",
            position: "absolute",
            right: "-1px",
            top: "50%",
            transform: "translateY(-50%)",
            height: "25px",
            width: "1px",
            backgroundColor: theme.colors.primaryFontColor,
            transition: "background-color 150ms ease",
          },
        },
        "&:hover": {
          "&:after": {
            backgroundColor: theme.colors.primary["500"],
          },
        },
      },
    },
  };
};

export default withGlobalContext(withStyles(styles)(RenderNavItems));
